<template>
	<div class="row-item row-item--color">
		<field-checkbox
			v-model:checked="model.enabled"
			:name="enabledName"
			:locked="enabledLocked"
			:indeterminate="checkboxIndeterminate"
			:aria-label="'border-checkbox'"
		></field-checkbox>
		<field-colorpicker
			v-model:color-value="model.color"
			:transparency="true"
		></field-colorpicker>
	</div>
	<div class="row-item">
		<div class="field-row">
			<field-regular
				:label="t('field.w')"
				:aria-label="'border-width'"
				:label-inline="true"
				:field-item-classname="'max-width--80 max-width--120:desktop'"
				:unit="t('field.px')"
				:numbers-only="true"
				v-model:model-value="model.width"
			></field-regular>
			<field-select
				:label="t('field.appearance.style')"
				:aria-label="'border-style'"
				:label-inline="true"
				:options="BORDER_STYLE"
				:by-value="'value'"
				:property="'name'"
				v-model:selected="model.style"
			></field-select>
		</div>
	</div>
</template>

<script>
import FieldCheckbox from '@/components/fields/FieldCheckbox';
import FieldRegular from '@/components/fields/FieldRegular';
import FieldColorpicker from '@/components/fields/FieldColorpicker';
import FieldSelect from '@/components/fields/FieldSelect';
import {BORDER_STYLE} from "@/models/node/BORDER_STYLE";
import {computed, reactive} from 'vue';
import {useI18n} from 'vue-i18n';
export default {
	components: {
		FieldCheckbox,
		FieldRegular,
		FieldColorpicker,
		FieldSelect
	},
	props: {
		enabled: {
			type: Boolean,
		},
		enabledLocked: {
			type: Boolean,
			default: false
		},
		enabledName: {
			type: String,
		},
		checkboxIndeterminate: {
			type: Boolean,
			default: false
		},
		color: {
			type: [String, Object]
		},
		width: {
			type: Number,
		},
		style: {
			type: [String, Object]
		}
	},
	setup(props, {emit}) {
		const {t} = useI18n();
		const modelEnabled = computed({
			get(){return props.enabled},
			set(value){emit('update:enabled', value)}
		})
		const modelColor = computed({
			get(){return props.color},
			set(value){emit('update:color', value)}
		})
		const modelWidth = computed({
			get(){return props.width},
			set(value){emit('update:width', value)}
		})
		const modelStyle = computed({
			get(){return props.style},
			set(value){emit('update:style', value)}
		})
		
		const model = reactive({
			enabled: modelEnabled,
			color: modelColor,
			width: modelWidth,
			style: modelStyle
		})
		
		return {
			t,
			model,
			BORDER_STYLE,
		}
	}
}
</script>

<style lang="scss">

</style>
